export const version = 'berater-v1.16.0-SNAPSHOT-2a8bb16737ffda03f7491f285475e2b811f786c4';